class StrapiClient {
  private baseUrl: string

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl
  }

  async request<T>(endpoint: string, options?: RequestInit): Promise<T> {
    try {
      if (!this.baseUrl) {
        console.warn(
          '[Strapi Client] VITE_STRAPI_URL environment variable is not set. ' +
            'Request to %s will not be made. Configure VITE_STRAPI_URL in .env to enable Strapi integration.',
          endpoint,
        )
        return {} as T
      }

      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        headers: { 'Content-Type': 'application/json' },
        ...options,
      })

      if (response.status >= 400) {
        const data = await response.json()
        throw new Error(data.message || 'An unknown error occurred')
      }

      return response.json()
    } catch (error) {
      console.error('[Strapi Client] Request failed:', {
        endpoint,
        error: error instanceof Error ? error.message : String(error),
      })
      return {} as T
    }
  }
}

export const client = new StrapiClient(import.meta.env.VITE_STRAPI_URL)
